<script setup>
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import MyLoadsDesktopButtonComponent from './MyLoadsDesktopButtonComponent.vue';

// showHeroSection() {
//   return (
//     (!this.latest_carrier_eld_provider?.integration?.id ||
//       this.hasInvalidEldCredentials ||
//       this.hasUnverifiedEldCredentials) &&
//     this.latest_carrier_eld_provider_has_loaded
//   );
//   // return this.latest_carrier_eld_provider?.id > 0 && this.latest_carrier_eld_provider_has_loaded;
// },

//     latest_carrier_eld_provider() {
//   if (this.$store.state.onboardingPacket?.latest_carrier_eld_provider) {
//     return this.$store.state.onboardingPacket?.latest_carrier_eld_provider;
//   } else if (
//     this.$store.state.carriers?.carrierData?.latest_carrier_eld_provider
//   ) {
//     return this.$store.state.carriers?.carrierData
//       ?.latest_carrier_eld_provider;
//   }
//   return null;
// },

// hasInvalidEldCredentials() {
//   return (
//     (this.latest_carrier_eld_provider?.integration
//       ?.eld_credentials_verified === false &&
//       this.latest_carrier_eld_provider?.connect_channel
//         ?.is_auto_eld_credentials) ||
//     this.latest_carrier_eld_provider?.integration?.revoked_at !== null
//   );
// },
// hasUnverifiedEldCredentials() {
//   return (
//     this.latest_carrier_eld_provider?.integration
//       ?.eld_credentials_verified === null &&
//     this.latest_carrier_eld_provider?.connect_channel
//       ?.is_auto_eld_credentials
//   );
// },
// hasValidEldCredentials() {
//   return (
//     this.latest_carrier_eld_provider?.integration
//       ?.eld_credentials_verified &&
//     this.latest_carrier_eld_provider?.connect_channel
//       ?.is_auto_eld_credentials
//   );
// },

const { containerClass } = defineProps({
  containerClass: {
    type: String,
    required: false,
    default: 'w-full',
  },
});
const defaultTitle = 'Connect your ELD';
const defaultMessage = 'Build trust and visibility to get more freight';
const title = ref(defaultTitle);
const buttonText = ref(defaultTitle);
const message = ref(defaultMessage);
const store = useStore();
const handleConnectEldClick = () => {
  if (buttonText.value !== defaultTitle) {
    store.commit('integrations/setUpdateEld', true);
  }
  store.commit('myLoadsStore/setShowConnectEldDialog', true);
};
const showEldButton = ref(false);
const hasLatestEldProviderLoaded = computed(
  () => store.state.onboardingPacket?.hasLatestEldProviderLoaded
);
const latestEldCarrierProvider = computed(
  () => store.state.onboardingPacket?.latest_carrier_eld_provider
);
const hasInvalidEldCredentials = computed(() => {
  return (
    (latestEldCarrierProvider.value?.integration?.eld_credentials_verified ===
      false &&
      latestEldCarrierProvider.value?.connect_channel
        ?.is_auto_eld_credentials) ||
    latestEldCarrierProvider.value?.integration?.revoked_at !== null
  );
});
const hasUnverifiedEldCredentials = computed(() => {
  return (
    latestEldCarrierProvider.value?.integration?.eld_credentials_verified ===
      null &&
    latestEldCarrierProvider.value?.connect_channel?.is_auto_eld_credentials
  );
});
watch(
  () => hasLatestEldProviderLoaded.value,
  (newValue) => {
    if (newValue) {
      if (
        (!latestEldCarrierProvider.value?.integration?.id ||
          hasInvalidEldCredentials.value ||
          hasUnverifiedEldCredentials.value) &&
        latestEldCarrierProvider.value?.connect_channel?.eld_type !==
          'eld_exempt' &&
        !latestEldCarrierProvider.value?.has_setup_manual_connection
      ) {
        showEldButton.value = true;
        if (!latestEldCarrierProvider.value?.integration?.id) {
          title.value = defaultTitle;
          buttonText.value = defaultTitle;
          message.value = defaultMessage;
        } else if (hasInvalidEldCredentials.value) {
          title.value = 'Invalid ELD Credentials';
          buttonText.value = 'Update Credentials';
          message.value = `${latestEldCarrierProvider.value?.connect_channel?.name}
                    account credentials are invalid`;
        } else if (hasUnverifiedEldCredentials.value) {
          title.value = 'ELD Connection in Progress';
          buttonText.value = 'Update Credentials';
          message.value = `We're currently working on connecting
                    ${latestEldCarrierProvider.value?.connect_channel?.name}`;
        }
      } else {
        showEldButton.value = false;
      }
    }
  }
);
</script>

<template>
  <div
    v-if="showEldButton"
    class="flex flex-col items-center justify-center gap-4 self-stretch overflow-hidden rounded-xl bg-white p-4 outline outline-1 outline-offset-[-1px] outline-neutral-300-a"
    :class="containerClass"
  >
    <div
      class="flex h-[150px] flex-col items-center justify-evenly gap-2 self-stretch"
    >
      <div class="relative h-[52px] overflow-hidden">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="52"
          height="52"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.82725 11.191C9.63792 3.38165 22.3019 3.38165 30.1113 11.191C30.2042 11.2839 30.2779 11.3941 30.3282 11.5155C30.3785 11.6369 30.4044 11.7669 30.4044 11.8983C30.4044 12.0297 30.3785 12.1598 30.3282 12.2811C30.2779 12.4025 30.2042 12.5128 30.1113 12.6057L29.4046 13.3123C29.2171 13.4996 28.9629 13.6048 28.6979 13.6048C28.4329 13.6048 28.1788 13.4996 27.9913 13.3123C21.3513 6.67365 10.5873 6.67365 3.94859 13.3123C3.76109 13.4996 3.50692 13.6048 3.24192 13.6048C2.97692 13.6048 2.72275 13.4996 2.53525 13.3123L1.82859 12.6057C1.64132 12.4182 1.53613 12.164 1.53613 11.899C1.53613 11.634 1.64132 11.3798 1.82859 11.1923L1.82725 11.191ZM6.06992 15.4337C11.5366 9.96698 20.4019 9.96698 25.8699 15.4337C25.9628 15.5265 26.0366 15.6368 26.0869 15.7582C26.1372 15.8795 26.163 16.0096 26.163 16.141C26.163 16.2724 26.1372 16.4024 26.0869 16.5238C26.0366 16.6452 25.9628 16.7555 25.8699 16.8483L25.1633 17.555C25.0704 17.6481 24.96 17.722 24.8385 17.7724C24.717 17.8228 24.5868 17.8488 24.4553 17.8488C24.3237 17.8488 24.1935 17.8228 24.072 17.7724C23.9505 17.722 23.8401 17.6481 23.7473 17.555C21.6844 15.4922 18.8865 14.3333 15.9693 14.3333C13.052 14.3333 10.2541 15.4922 8.19125 17.555C8.00375 17.7423 7.74959 17.8474 7.48459 17.8474C7.21959 17.8474 6.96542 17.7423 6.77792 17.555L6.07125 16.8483C5.88399 16.6608 5.7788 16.4067 5.7788 16.1417C5.7788 15.8767 5.88399 15.6225 6.07125 15.435L6.06992 15.4337ZM10.3419 19.6763C11.0848 18.9333 11.9668 18.3439 12.9375 17.9418C13.9082 17.5397 14.9486 17.3327 15.9993 17.3327C17.0499 17.3327 18.0903 17.5397 19.061 17.9418C20.0317 18.3439 20.9137 18.9333 21.6566 19.6763C21.7495 19.7692 21.8232 19.8795 21.8735 20.0008C21.9238 20.1222 21.9497 20.2523 21.9497 20.3837C21.9497 20.515 21.9238 20.6451 21.8735 20.7665C21.8232 20.8879 21.7495 20.9981 21.6566 21.091L20.9499 21.7977C20.8571 21.8906 20.7468 21.9643 20.6254 22.0146C20.5041 22.0649 20.374 22.0908 20.2426 22.0908C20.1112 22.0908 19.9811 22.0649 19.8598 22.0146C19.7384 21.9643 19.6281 21.8906 19.5353 21.7977C19.0709 21.3332 18.5197 20.9648 17.913 20.7134C17.3063 20.4621 16.656 20.3327 15.9993 20.3327C15.3425 20.3327 14.6922 20.4621 14.0855 20.7134C13.4788 20.9648 12.9276 21.3332 12.4633 21.7977C12.2758 21.9849 12.0216 22.0901 11.7566 22.0901C11.4916 22.0901 11.2374 21.9849 11.0499 21.7977L10.3433 21.091C10.156 20.9035 10.0508 20.6493 10.0508 20.3843C10.0508 20.1193 10.156 19.8652 10.3433 19.6777L10.3419 19.6763ZM14.5846 23.919C14.7703 23.7331 14.9909 23.5857 15.2336 23.4851C15.4763 23.3845 15.7365 23.3327 15.9993 23.3327C16.262 23.3327 16.5222 23.3845 16.7649 23.4851C17.0077 23.5857 17.2282 23.7331 17.4139 23.919C17.5068 24.0119 17.5806 24.1221 17.6309 24.2435C17.6812 24.3649 17.707 24.4949 17.707 24.6263C17.707 24.7577 17.6812 24.8878 17.6309 25.0092C17.5806 25.1305 17.5068 25.2408 17.4139 25.3337L16.7073 26.0403C16.6144 26.1332 16.5041 26.207 16.3828 26.2573C16.2614 26.3076 16.1313 26.3334 15.9999 26.3334C15.8685 26.3334 15.7385 26.3076 15.6171 26.2573C15.4957 26.207 15.3855 26.1332 15.2926 26.0403L14.5859 25.3337C14.3987 25.1462 14.2935 24.892 14.2935 24.627C14.2935 24.362 14.3987 24.1078 14.5859 23.9203L14.5846 23.919Z"
            fill="#F8C612"
          />
        </svg>
      </div>
      <div class="flex flex-col items-start justify-start gap-1 self-stretch">
        <div
          class="text-color-text-neutral-bold-default justify-start self-stretch text-center font-['Poppins'] text-base font-semibold leading-normal tracking-tight"
        >
          {{ title }}
        </div>
        <div
          class="text-color-text-neutral-subtlest-default justify-start self-stretch text-center font-['Poppins'] text-sm font-medium leading-tight tracking-tight"
        >
          {{ message }}
        </div>
      </div>
    </div>
    <MyLoadsDesktopButtonComponent
      button-class="primary-button px-3 w-full max-w-[300px] rounded-[3px] h-12"
      text-class="text-sm font-medium leading-10 tracking-tight"
      :button-text="buttonText"
      @button-click="handleConnectEldClick"
    />
  </div>
</template>

<style lang="scss" scoped></style>
